export const frontendProfile = {
  role: 'header.role.frontend',
  summary: 'summary.description.frontend',
  skills: {
    frontend: [
      'skills.html5',
      'skills.css3',
      'skills.javascript',
      'skills.typescript',
      'skills.reactjs',
      'skills.nextjs',
      'skills.tailwindcss'
    ],
    architecture: [
      'skills.clean-code',
      'skills.responsive-design',
      'skills.accessibility',
      'skills.seo'
    ],
    testing: [
      'skills.vitest',
      'skills.testing-library',
      'skills.playwright'
    ],
    tools: [
      'skills.git',
      'skills.vercel'
    ]
  },
  certifications: [
    {
      title: 'ReactJS',
      issuer: 'Rocketseat',
      year: 2025,
      skills: ['skills.reactjs', 'skills.typescript']
    },
    {
      title: 'Fundamentos do React',
      issuer: 'Rocketseat',
      year: 2024,
      skills: ['skills.reactjs', 'skills.javascript']
    },
    {
      title: 'Aprofundando em Next.js',
      issuer: 'Rocketseat',
      year: 2025,
      skills: ['skills.nextjs']
    },
    {
      title: 'Aprofundando em Hooks',
      issuer: 'Rocketseat',
      year: 2024,
      skills: ['skills.reactjs']
    },
    {
      title: 'Design System',
      issuer: 'Rocketseat',
      year: 2025,
      skills: ['skills.reactjs', 'skills.typescript']
    }
  ],
  experiences: [
    {
      role: 'experience.role.expert',
      company: 'experience.company.teleperformance',
      period: 'experience.period.teleperformance',
      location: 'experience.location.teleperformance',
      achievements: [
        'experience.achievements.teleperformance.0',
        'experience.achievements.teleperformance.1'
      ],
      skills: ['Comunicação', 'Resolução de Problemas']
    },
    {
      role: 'experience.role.production',
      company: 'experience.company.debem',
      period: 'experience.period.debem',
      location: 'experience.location.debem',
      achievements: [
        'experience.achievements.debem.0',
        'experience.achievements.debem.1'
      ],
      skills: ['Trabalho em Equipe', 'Atenção aos Detalhes']
    }
  ],
  projects: [
    {
      title: 'projects.tesouros.title',
      description: 'projects.tesouros.description',
      skills: ['React', 'TypeScript', 'TailwindCSS', 'PWA'],
      link: 'https://github.com/rafaumeu/tesouros-portal',
      demo: 'https://tesouros-portal.vercel.app'
    },
    {
      title: 'projects.ignitecall.title',
      description: 'projects.ignitecall.description',
      skills: ['Next.js', 'TypeScript', 'TailwindCSS', 'OAuth'],
      link: 'https://github.com/rafaumeu/ignitecall-app',
      demo: 'https://ignitecall-app.vercel.app'
    },
    {
      title: 'projects.devstore.title',
      description: 'projects.devstore.description',
      skills: ['Next.js', 'TypeScript', 'TailwindCSS', 'Stripe'],
      link: 'https://github.com/rafaumeu/ecommerce-next',
      demo: 'https://devstorerdz.netlify.app'
    },
    {
      title: 'projects.pizzashop.title',
      description: 'projects.pizzashop.description',
      skills: ['React', 'TypeScript', 'TailwindCSS', 'Vitest', 'Playwright'],
      link: 'https://github.com/rafaumeu/pizza-shop',
      demo: 'https://pizza-shop-five-sigma.vercel.app'
    }
  ],
  atsKeywords: 'react reactjs typescript nextjs tailwindcss html5 css3 javascript frontend pwa vitest playwright accessibility'
};
